export { default } from './CompactTitle';



// WEBPACK FOOTER //
// ./app/components/shared/CompactTitle/index.js